import { CreditCard } from '@material-ui/icons';
import { Huddle, Payment } from 'lib/generated/graphql';
import moment from 'moment';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import Divider from 'src/shared-components/Divider';

export const PayButton = ({ huddle }: { huddle: Huddle }) => {
  const router = useRouter();
  const { slug } = router.query;

  const navigateToPay = () => {
    router.push(`/huddles/${huddle?.request?.slug}/proposal/${huddle.proposal.id}/pay`);
  };

  return (
    <button
      className=" text-black rounded-lg font-small flex items-center whitespace-nowrap underline"
      onClick={navigateToPay ? () => navigateToPay() : null}
    >
      <span className="font-xs ">Pay Now</span>
    </button>
  );
};

const PaymentRow = ({
  huddle,
  payment,
  intervalStartDate,
}: {
  huddle: Huddle;
  payment: Payment;
  intervalStartDate: any;
}) => {
  return (
    <div className="w-full">
      <div className="flex justify-between mt-8 mb-6">
        <div className="flex flex-row basis-1/6">
          <div className="flex flex-row">
            <CreditCard className="mr-5" />
          </div>
          <div className="">
            {intervalStartDate !== 'Upcoming' && (
              <div className="items-center">{moment(intervalStartDate).format('MMM DD, YYYY').valueOf()}</div>
            )}
            {intervalStartDate === 'Upcoming' && <div className="">Available Soon</div>}
          </div>
        </div>
        <div className="basis-1/6">
          <div className="">${Number(payment.totalAmount).toLocaleString()}</div>
        </div>

        <div className="basis-1/6">
          <div className="">{payment.paid === true && <div>Paid</div>}</div>
          <div className="">{payment.paid !== true && <div>Not Paid</div>}</div>
        </div>

        <div className="flex basis-1/6">
          {payment.paid && (
            <div className="underline">
              <Link href={payment.invoiceUrl} passHref>
                <a className="underline" target={'_blank'}>
                  View Invoice
                </a>
              </Link>
            </div>
          )}
          {!payment.invoiceSent && <div>Invoice Unavailable</div>}

          {payment.invoiceSent && !payment.paid && (
            <div className="">
              <PayButton huddle={huddle} />
            </div>
          )}
        </div>
      </div>
      <Divider />
    </div>
  );
};

export default PaymentRow;
